'use strict';

exports.__esModule = true;

var _reactRouter = require('react-router');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _reactRouter.Route;
  }
});


//////////////////
// WEBPACK FOOTER
// ./~/gatsby/~/react-router-dom/Route.js
// module id = ./node_modules/gatsby/node_modules/react-router-dom/Route.js
// module chunks = 2